import { useTranslation } from "react-i18next";

export function LoadingState({ messageKey = "common.loading" }: { messageKey?: string }) {
  const { t } = useTranslation();
  return <p className="text-sm text-muted-foreground">{t(messageKey)}</p>;
}
